const axios = require('axios');
const createAd = require('./createAd');
const adsTitle = require('./adsTitle');
const adsLink = require('./adsLink');
const filterAds = require('./filterAds');
const attachHandlers = require('./attachHandlers');

module.exports = () => {
  axios('//i2icenter.org/wp-json/acf/v3/options/ad-manager')
    .then(response => {
      if (! response.data.acf.scheduled_ads) { return; }

      const { ads_area_title, bottom_link } = response.data.acf;

      const ads = response.data.acf.scheduled_ads;

      const currentAds = ads.filter(filterAds);

      const itemsToRemove = currentAds.length - 3;
      for (let i = 0; i < itemsToRemove; i++) {
        const randIndex = Math.floor(Math.random() * 3);
        currentAds.splice(randIndex, 1);
      }

      const createdAds = currentAds.map(createAd);

      const adsArea = document.getElementById('ads');

      if (createdAds.length && adsArea) {
        document.querySelector('body').classList.add('active-ads');
        if (adsTitle(ads_area_title)) {
          adsArea.appendChild(adsTitle(ads_area_title));
        }

        createdAds.forEach(ad => adsArea.appendChild(ad));

        if(bottom_link) {
          adsArea.appendChild(adsLink(bottom_link));
        }
        attachHandlers();

        
      }
    })
    .catch(error => console.error(error));
}
